import type { APIResult } from "./types";

import { getMaintenanceComplianceStatus } from "./generated/calls/maintenance-compliance-status/maintenance-compliance-status";
import type { MaintenanceComplianceStatus as MaintenanceComplianceStatusDTO } from "./generated/models";
import { buildHeaders } from "./helpers/headerHelper";
import { postgrestError } from "./helpers/postgrestErrorHelper";

export type { MaintenanceComplianceStatusDTO };

/**
 * Fetches all fleet maintenance compliance statuses from the API.
 *
 * Returns an API result containing the fetched compliance statuses, or a
 * controlled failure if the request could not be completed.
 */
export async function fetchFleetMaintenanceComplianceStatus(): Promise<
  APIResult<MaintenanceComplianceStatusDTO[]>
> {
  try {
    const headers = buildHeaders();
    const complianceStatusFetchRes = await getMaintenanceComplianceStatus(
      undefined,
      { headers },
    );

    switch (complianceStatusFetchRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: complianceStatusFetchRes.data,
        };
      default:
        throw postgrestError("Fetch failed", complianceStatusFetchRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
